import { render } from "./ProviderToolsSpotlight.vue?vue&type=template&id=792f387a"
import script from "./ProviderToolsSpotlight.vue?vue&type=script&lang=js"
export * from "./ProviderToolsSpotlight.vue?vue&type=script&lang=js"

import "./ProviderToolsSpotlight.vue?vue&type=style&index=0&id=792f387a&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__